import * as React from 'react'
import FormControl from '@mui/material/FormControl'
import MenuItem from '@mui/material/MenuItem'
import { TextField, OutlinedTextFieldProps } from '@mui/material'

export interface ComboBoxProps extends OutlinedTextFieldProps {
  data?: any[],
  emptyItem?: boolean,
  valueName?: string,
  displayName?: string,
}

/**
 * コンボボックス
 */
export const ComboBox: React.FC<ComboBoxProps> = (props) => {
  const { data, valueName, displayName, emptyItem,...textFieldProps } = props
  const itemValueName = valueName ? valueName : 'typeValCd'
  const itemDisplayName = displayName ? displayName : 'typeValName'

  return (
    <FormControl fullWidth>
      <TextField select {...textFieldProps}>
        {
          emptyItem && <MenuItem value={''}></MenuItem>
        }
        {
          data && data.map((item) => <MenuItem key={item[itemValueName]} value={item[itemValueName]}>{item[itemDisplayName]}</MenuItem>)
        }
      </TextField>
    </FormControl>
  )
}

export default ComboBox
